export const PERFIL_AUTENTICADO = {
  CAGEO: "CAGEO",
  CAVISTORIA: "CAVISTORIA",
  CREDENCIADO: "CREDENCIADOS",
  GESTAO_DE_CREDENCIADOS: "GESTAO_DE_CREDENCIADOS",
};

export const TIPO_CONVERSA = {
  NOTIFICACAO: "NOTIFICACAO",
  SOLICITACAO_RETIFICACAO: "SOLICITACAO_RETIFICACAO",
  RESULTADO_ANALISE: "RESULTADO_ANALISE",
  TODOS: "TODOS",
};

export const PUBLIC_ROUTES = ["credenciados/cadastro", "editais"];

export const ROUTE_GROUPS = {
  CAGEO: "CAGEO",
  CAVISTORIA: "CAVISTORIA",
  CREDENCIADO: "CREDENCIADO",
  MENSAGENS: "MENSAGENS",
  SOLICITACOES: "SOLICITACOES",
  SOLICITACOES_CAGEO: "SOLICITACOES_CAGEO",
  CREDENCIADOS: "CREDENCIADOS",
  LISTAGEM_EDITAIS: "LISTAGEM_EDITAIS",
  CREDENCIAR_PROCESSOS: "CREDENCIAR_PROCESSOS",
};

export const MENSAGENS_TIPO_DOCUMENTO_CREDENCIADO = {
  DOCUMENTO_IDENTIFICACAO: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  COMPROVANTE_INCRA: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_QUITACAO_ORGAO_CLASSE: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_REGISTRO_ORGAO_CLASSE: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_QUITACAO_ORGAO_CLASSE_E_CERTIDAO_REGISTRO_ORGAO_CLASSE: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_ATRIBUICAO_ORGAO_CLASSE: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_NEGATIVA_INCRA_ORGAO_CLASSE: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CONSULTA_PENALIDADE_INCRA_SIGEF: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  CERTIDAO_QUITACAO: {
    texto:
      'Deverá ser enviada uma cópia. Quando necessário, demais documentos podem ser anexados selecionando a opção "Outros"',
  },
  FOTO_PERFIL: {
    texto:
      "Para uma melhor identificação, anexe uma foto nítida, com boa iluminação e, de preferência, sobre um fundo branco ou neutro.",
  },
  OUTROS: {
    texto: "Usado para anexar demais documentos.",
  },
};
